import * as actions from "./types";

const initialState = {
  groups: [],
  users: [],
  user: {},
  isLoading: false,
  groupsLoading: false,
  error: null,
  success: false,
  permissions: []
};

export default function(state = initialState, { type, payload = null }) {
  switch (type) {
    case actions.GET_USER_START:
      return loadingStart(state);
    case actions.GET_USER_SUCCESS:
      return getUserSuccess(state, payload);
    case actions.GET_USER_FAIL:
      return throwError(state, payload);
    case actions.EDIT_USER_START:
      return loadingStart(state);
    case actions.EDIT_USER_SUCCESS:
      return editUserSuccess(state, payload);
    case actions.EDIT_USER_FAIL:
      return throwError(state, payload);
    case actions.GET_USER_GROUPS_START:
      return getUserGroupsStart(state);
    case actions.GET_USER_GROUPS_SUCCESS:
      return getUserGroupsSuccess(state, payload);
    case actions.GET_USER_GROUPS_FAIL:
      return throwError(state, payload);
    case actions.GET_USER_GROUP_START:
      return loadingStart(state);
    case actions.GET_USER_GROUP_SUCCESS:
      return getUserGroupSuccess(state, payload);
    case actions.GET_USER_GROUP_FAIL:
      return throwError(state, payload);
    case actions.GET_USERS_START:
      return loadingStart(state);
    case actions.GET_USERS_SUCCESS:
      return getUsersSuccess(state, payload);
    case actions.GET_USERS_FAIL:
      return throwError(state, payload);
    case actions.CREATE_USER_START:
      return loadingStart(state);
    case actions.CREATE_USER_SUCCESS:
      return createUserSuccess(state, payload);
    case actions.CREATE_USER_FAIL:
      return throwError(state, payload);
    case actions.CLEAR_USER:
      return clearUser(state);
    case actions.EDIT_USER_GROUP_START:
      return loadingStart(state);
    case actions.EDIT_USER_GROUP_SUCCESS:
      return editUserGroupSuccess(state, payload);
    case actions.EDIT_USER_GROUP_FAIL:
      return throwError(state, payload);
    case actions.REMOVE_USER_START:
      return loadingStart(state);
    case actions.REMOVE_USER_SUCCESS:
      return removeUserSuccess(state);
    case actions.REMOVE_USER_FAIL:
      return throwError(state, payload);
    default:
      return state;
  }
}

function clearUser(state) {
  state = Object.assign({}, state, {
    user: {}
  });
  return state;
}

function loadingStart(state) {
  state = Object.assign({}, state, {
    isLoading: true
  });
  return state;
}

function throwError(state, payload) {
  state = Object.assign({}, state, {
    isLoading: false,
    error: payload,
    success: false
  });
  return state;
}

function getUserSuccess(state, payload) {
  state = Object.assign({}, state, {
    isLoading: false,
    user: payload
  });
  return state;
}

function editUserSuccess(state, payload) {
  state = Object.assign({}, state, {
    isLoading: false,
    user: payload,
    success: true
  });
  return state;
}

function getUserGroupsStart(state, payload) {
  state = Object.assign({}, state, {
    groupsLoading: true
  });
  return state;
}

function getUserGroupsSuccess(state, payload) {
  state = Object.assign({}, state, {
    groupsLoading: false,
    groups: payload
  });
  return state;
}

function editUserGroupSuccess(state, payload) {
  state = Object.assign({}, state, {
    isLoading: false,
    group: payload
  });
  return state;
}

function getUserGroupSuccess(state, payload) {
  state = Object.assign({}, state, {
    isLoading: false,
    group: payload
  });
  return state;
}

function getUsersSuccess(state, payload) {
  state = Object.assign({}, state, {
    isLoading: false,
    users: payload,
    total: payload.count
  });
  return state;
}

function createUserSuccess(state, payload) {
  state = Object.assign({}, state, {
    isLoading: false,
    user: payload,
    success: true
  });
  return state;
}

function removeUserSuccess(state) {
  state = Object.assign({}, state, {
    isLoading: false,
    user: null,
    success: true
  });
  return state;
}



// WEBPACK FOOTER //
// ./src/system/store/AdminUsers/reducers.js